import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback } from "react";
import { SInputV2 } from "../../SInputV2";
import { SSlider } from "../../SSlider";
const units = [
    "%"
];
const globalUnits = [
    "auto",
    "inherit",
    "initial",
    "unset"
];
const placeholderUnits = [
    "none"
];
const valueTypes = [
    ...units,
    ...globalUnits,
    ...placeholderUnits
];
export const CSSPercentageEditor = (props)=>{
    const { value, onChangeValue } = props;
    // We know now that literalValue is `css-percentage` or `css-string`
    const getNextState = (currentState, action)=>{
        const { value } = currentState;
        const literValueIsGlobal = value?.unit == "none";
        const literalValueHasUnit = value && value?.unit !== "none";
        switch(action.type){
            case "KEY_DOWN":
                {
                    const { event } = action;
                    const key = event.key;
                    const length = value?.value;
                    const KeyMap = {
                        ArrowUp: event.shiftKey ? 10 : 1,
                        ArrowDown: event.shiftKey ? -10 : -1
                    };
                    if (key in KeyMap) {
                        const parsedLength = parseFloat(length || "");
                        const newValue = isNaN(parsedLength) ? 0 : parsedLength + KeyMap[key];
                        if (!literValueIsGlobal) {
                            return {
                                value: {
                                    type: "css-percentage",
                                    unit: value?.unit,
                                    value: Math.min(100, Math.max(0, newValue)).toString()
                                }
                            };
                        } else {
                            return {
                                value: {
                                    type: "css-percentage",
                                    unit: "%",
                                    value: Math.min(100, Math.max(0, newValue)).toString()
                                }
                            };
                        }
                    }
                    break;
                }
            case "DROPDOWN_SELECT":
                {
                    const { unit } = action;
                    if (globalUnits.includes(unit)) {
                        return {
                            value: {
                                type: "css-percentage",
                                value: unit,
                                // Idk why this isn't validating
                                unit: "none"
                            }
                        };
                    }
                    return {
                        value: {
                            type: "css-percentage",
                            value: (literValueIsGlobal ? "" : value?.value) || "",
                            unit: unit
                        }
                    };
                }
            case "INPUT_CHANGE":
                {
                    const { value } = action;
                    const literalValue = currentState.value;
                    let length = literalValue?.value;
                    let unit = literalValue?.type === "css-percentage" ? false ? null : literalValue.unit : null;
                    // Snap to units, `12px` -> `12` `px`,
                    // `auto` -> `auto` `none`
                    for (let type of valueTypes){
                        if (value.includes(type)) {
                            unit = type;
                            const parsedLength = value.match(/[a-zA-Z]+|[0-9\.-0-9]+|[%]+/g);
                            if (parsedLength && parsedLength[0]) {
                                if (globalUnits.includes(type)) {
                                    unit = "none";
                                    length = type;
                                } else {
                                    length = parsedLength[0];
                                }
                                return {
                                    value: {
                                        type: "css-percentage",
                                        value: Math.min(100, Math.max(0, parseFloat(length))) + "",
                                        unit: unit
                                    }
                                };
                            }
                        }
                    }
                    // We already have a unit, so just update the value
                    // this could also result in a weird value but that's
                    // ok for now
                    if (literalValueHasUnit) {
                        return {
                            value: {
                                type: "css-percentage",
                                value: value,
                                unit: literalValue?.unit
                            }
                        };
                    }
                    // This may result in a weird value if you're typing 'aut' 'px'
                    // See if we can parse the value as a number
                    const parsedValue = parseFloat(value);
                    if (!isNaN(parsedValue)) {
                        return {
                            value: {
                                type: "css-percentage",
                                value: value,
                                // Picking up the default unit
                                unit: "%"
                            }
                        };
                    }
                    // Leave this as raw to indicate
                    // that we don't know what the value is
                    return {
                        value: {
                            type: "css-percentage",
                            value: value,
                            unit: "%"
                        }
                    };
                }
        }
        return {
            value: null
        };
    };
    const dispatch = useCallback((action)=>{
        const nextState = getNextState({
            value
        }, action);
        if (nextState.value) {
            onChangeValue && onChangeValue(nextState.value);
        }
    }, [
        getNextState,
        value
    ]);
    return /*#__PURE__*/ _jsxs("div", {
        className: "bg-grayscale-dark rounded-md border border-white/10 grid grid-cols-[1fr,auto,auto] items-center",
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "px-3 border-r border-white/10",
                children: /*#__PURE__*/ _jsx(SSlider, {
                    min: 0,
                    max: 100,
                    step: 1,
                    className: "!h-[30px] !w-full",
                    value: parseInt(value?.value === undefined ? "100" : value.value),
                    onChange: (value)=>{
                        dispatch({
                            type: "INPUT_CHANGE",
                            value: value.toString()
                        });
                    }
                })
            }),
            /*#__PURE__*/ _jsx(SInputV2, {
                borderless: true,
                type: "number",
                min: 0,
                max: 100,
                tabIndex: 1,
                className: "text-[13px] !px-2 !h-[30px] !py-0 text-center",
                value: value?.value || "",
                placeholder: "100",
                onChange: (e)=>dispatch({
                        type: "INPUT_CHANGE",
                        value: e.target.value
                    })
            }),
            /*#__PURE__*/ _jsx("p", {
                className: "text-[13px] opacity-70  pr-2",
                children: "%"
            })
        ]
    });
};
